import { ReactNode } from 'react'
import { Segmented } from 'antd'
export type DspTabKey = 'basic' | 'filtering'
export type DspTabItem = {
    key: DspTabKey
    label: string
    disabled?: boolean
}
type DspTabsProps = {
    tabs: DspTabItem[]
    activeTab: DspTabKey
    onTabChange: (key: DspTabKey) => void
}
export const dspTabs: DspTabItem[] = [
    { key: 'basic', label: 'Basic Details' },
    { key: 'filtering', label: 'Filtering Options' },
]
const DspTabs = ({ tabs, activeTab, onTabChange }: DspTabsProps): ReactNode => {
    return (
        <Segmented
            value={activeTab}
            options={tabs.map((tab) => ({
                label: tab.label,
                value: tab.key,
                disabled: tab.disabled,
            }))}
            onChange={(value) => onTabChange(value as DspTabKey)}
        />
    )
}
export default DspTabs